/* eslint-disable react/jsx-props-no-spreading */
// mantine
import { Loader, Select, SelectProps } from '@mantine/core';
// utils
import { getProjectName } from '@/modules/Projects/Project.utils';
import { useProjectsQuery } from '@/services/designer/projects/projects.queries';

const ProjectSelect = ({ value, onChange, ...rest }: SelectProps) => {
    const { data: projects = [], isLoading } = useProjectsQuery();

    const options = projects.map((project) => ({
        label: getProjectName(project),
        value: project.id
    }));

    return (
        <Select
            data={options}
            leftSection={isLoading ? <Loader size="xs" /> : undefined}
            value={value}
            onChange={onChange}
            {...rest}
        />
    );
};

export default ProjectSelect;
